import { Controller } from 'stimulus';
import { GridStack } from 'gridstack';
import { initializeChart, adjustGraphDimensions } from "../packs/component_helpers";
import { initializeEngagementSliders, getAppliedParams } from '../packs/filter_helpers';
export default class extends Controller {
  static targets = ['entries', 'pagination', 'spinner', "dashboard", "customDateField"];

  initialize() {
    $(".spinner-div").removeClass("d-flex");
    $(".spinner-div").hide();
    this.render_filter_url = window.location.pathname.replace("/edit", "") + "/render_filter"
    this.chart_configuration = {}
  }

  connect() {
    let static_grid = false;
    let slug = $(this.dashboardTarget).data("slug");
    let is_static = $(this.dashboardTarget).data("static");
    if(is_static == "1"){ static_grid = true}
    let controller = this;
    
    let options = {
      staticGrid: static_grid,
      disableResize: true, 
      cellHeight: 10
    };

    let grid = GridStack.init(options);

    document.querySelectorAll('.dashboard-entries').forEach(dashboard => {
      this.intersectionObserver.observe(dashboard)
    });

    document.querySelectorAll(".component-container").forEach(elem => {
      controller.renderComponent(elem);
    })

    grid.on('resizestop', function(event, el) {
      controller.reRenderChartComponent(el)
    });

    grid.on('change', function(event, items) {
      if(items){
        items.forEach(function(item) {
          var component_id = item.el.id.replace("stack-item-", "");
          controller.updateComponentPosition(slug, component_id, item)
        });
      }
    });

    grid.on('added', function(event, items) {
      if(items){
        items.forEach(function(item) {
          var component_id = item.el.id.replace("stack-item-", "");
          controller.updateComponentPosition(slug, component_id, item)
          let elem = $(item.el).find(".component-container")
          controller.renderComponent(elem[0])
        });
      }
    });

    $('.grid-stack').data('gridstack-instance', grid);

    this.connectNewModalOpenEvent()
    
    $('body').on('click', 'input[name=chart-type]', function(event) {
      controller.updateChartConfiguration(event, "chart-type", "chart_type", "chartLayout")
    });

    $('body').on("click", "input[name=chart-scale]", function(event) {
      controller.updateChartConfiguration(event, "chart-scale", "chart_scale", "chartScale")
    });

    $('body').on("click", "input[name=hidePoints]", function(event) {
      controller.updateChartConfiguration(event, "hidePoints", "hide_points", "hidePoint")
    });
  }

  toggleSpinner(elem, action){
    if(action == "hide"){
      $(elem).find(".spinner-div").removeClass("d-flex");
      $(elem).find(".spinner-div").hide();
    } else {
      $(elem).find(".spinner-div").addClass("d-flex");
      $(elem).find(".spinner-div").show();

    }
  }

  updateChartConfiguration(event, input_name, param_name, config_type){
    var container = $(event.target).parents(".component-container");
    let value = event.target.value

    //update UI
    if(input_name == "hidePoints"){
      if ($(event.target).is(":checked")){
        $(event.target).parent().addClass("active")
      } else {
        $(event.target).parent().removeClass("active")
      }
      value = $(event.target).is(":checked")
    } else {
      var parent = container.find(`input[name=${input_name}]`).parent()
      parent.removeClass("active")
      $(event.target).parent().addClass("active")
    }

    //update URL
    let url = container.data("url");
    let params = this.getParamsFromURI(url);
    params.delete(param_name);
    params.append(param_name, value)
    url = url.split("?")[0] + "?" + params.toString();
    container.data("url", url)

    //Update Chart
    let elem_id = container.attr("id")
    var chart_container_id = `.line-chart-${elem_id}`
    
    this.chart_configuration[`${elem_id}`][config_type] = value
    var grid_item = $(`#stack-item-${elem_id} #${elem_id}`);
    initializeChart(chart_container_id, grid_item, this.chart_configuration[`${elem_id}`])
  }

  updateSharingStatus(event){
    event.preventDefault();

    let form = $(event.target);
    let json = this.convertFormToJSON(form);

    Rails.ajax({
      type: 'PATCH',
      url: form.attr('action'),
      data: $.param(json),
      dataType: 'json',
      success: (response) => {
        $('#sharing_modal').modal('hide');
        form.find('input[type="submit"]').attr("disabled", false);

        alert("Privacy options updated!");
      },   
      error: (response) => {
        alert(response.message);
      }
    });  


  }

  deleteComponent(event){
    event.preventDefault();

    let delete_trigger = $(event.target)
    if($(event.target).data("icon") == "trash-alt") delete_trigger = $(event.target).parent()

    const confirmMessage = delete_trigger.data("confirmMessage");
    if (confirmMessage && !confirm(confirmMessage)) return;

    let slug = $(this.dashboardTarget).data("slug");
    var elem = $(event.target).parents(".grid-stack-item")[0]

    if(!elem){
      console.error('Could not find grid-stack-item ancestor.');
      return;
    }

    var component_id = elem.id.replace("stack-item-", "");

    Rails.ajax({
      type: 'DELETE',
      url: `/dashboards/${slug}/dashboard_components/${component_id}`,
      dataType: 'json',
      success: (response) => {
        $(`#edit_modal_${component_id}`).modal('hide');
        let grid = $(".grid-stack").data("gridstack-instance");
        grid.removeWidget(elem, true, true)
      }

    });
  }

  reRenderChartComponent(el){
    var chart_view = $(el).find(".chart-component");

    if (chart_view){
      var vega_view = chart_view.data("vega-view");

      if (vega_view){
        let dimensions = adjustGraphDimensions(el.gridstackNode._rect.w, el.gridstackNode._rect.h)
        vega_view.width(dimensions.width).height(dimensions.height).run();
      }
    }
  }

  // keeping this here for future reference of how to update the height and width of chart without re-rendering the chart
  // reRenderChartComponent(el){
  //   var chart_view = $(el).find(".chart-component");

  //   if (chart_view){
  //     console.log("herer")

  //     var vega_view = chart_view.data("vega-view");

  //     if (vega_view){
  //       let graph_width = el.gridstackNode._rect.w*0.95
  //       let graph_height = el.gridstackNode._rect.h*0.85

  //       vega_view.width(graph_width).height(graph_height).run();
  //     }
  //   }
  // }

  updateComponentPosition(slug, component_id, item){
    Rails.ajax({
      type: 'PATCH',
      url: `/dashboards/${slug}/dashboard_components/${component_id}`,
      data: $.param({dashboard_component: {height: item.h, width: item.w, row: item.x, column: item.y}}),
      dataType: 'json',
      success: (response) => {
        console.log(response.message)
      }
    });
  }

  renderComponent(elem){
    this.toggleSpinner(elem, "show");

    Rails.ajax({
      type: 'GET',
      url: $(elem).data("url"),
      dataType: 'json',
      success: (response) => {
        this.toggleSpinner(elem, "hide");
        $(elem).find(".content").html(response);
        $(elem).find(".custom-date-fields").hide();

        var chart_container_id = `.line-chart-${elem.id}`
        if($(chart_container_id)) {
          var grid_item = $(`#stack-item-${elem.id} #${elem.id}`);
          this.initializeChartConfiguration(elem)
          initializeChart(chart_container_id, grid_item, this.chart_configuration[elem.id])
        }

        initializeEngagementSliders()
        this.resizeContainer(elem)
      }
    });
  }

  initializeChartConfiguration(container){
    this.chart_configuration[container.id] = {
      chartLayout: $(container).find(".chart-type-setting label.active input").val(),
      chartScale: $(container).find(".chart-scale-setting label.active input").val(),
      hidePoint: $(container).find(".hide-point-toggle label.active input").val() == "on"
    }
  }

  showCustomDateFields(event) {
    if($(event.target).is(':checked')){
      $(event.target).parent().find(".custom-date-fields").show();
    } else {
      $(event.target).parent().find(".custom-date-fields").hide();
    }
  }

  applyCustomDateFilter(event) {
    let component_ids = $(event.target).parents(".filter-component").data("componentIds");
    let published_at_from = $(event.target).parents(".custom-date-fields").find(".date_from").val();
    let published_at_to = $(event.target).parents(".custom-date-fields").find(".date_to").val();

    document.querySelectorAll(".component-container").forEach(elem => {
      if(component_ids.includes(parseInt(elem.id))){
        $(elem).find(".content").html("");
        this.toggleSpinner(elem, "show");

        let url = $(elem).data("url");
        let params = this.getParamsFromURI(url);

        params.delete("published_at_from");
        params.delete("published_at_to");

        params.append("published_at_from", published_at_from)
        params.append("published_at_to", published_at_to)

        url = url.split("?")[0] + "?" + params.toString();
        this.updateComponent(elem, url)
      }
    })

    let filter_component = $(event.target).parents(".filter-component")
    let button_elem = filter_component.find("button.dropdown-toggle");
    button_elem.text(`${published_at_from} - ${published_at_to}`);
  }

  updateGraphByAttribute(event){
    event.preventDefault();
    let elem = $(event.target).parents(".component-container")[0]
    let url = $(elem).data("url");
    let params = this.getParamsFromURI(url);

    params.delete("search_by");
    params.append("search_by", $(event.target).data("value"))

    url = url.split("?")[0] + "?" + params.toString();
    this.updateComponent(elem, url)
  }

  updateGraphInterval(event){
    event.preventDefault();
    let elem = $(event.target).parents(".component-container")[0]
    let url = $(elem).data("url");
    let params = this.getParamsFromURI(url);

    params.delete("group_by");
    params.append("group_by", $(event.target).data("value"))

    url = url.split("?")[0] + "?" + params.toString();
    this.updateComponent(elem, url)
  }

  updateLinkedComponents(event) {
    event.preventDefault();
    let filter_component = $(event.target).parents(".filter-component")
    let component_ids = filter_component.data("componentIds");
    let param_name = filter_component.data("paramName");

    let applied_params = getAppliedParams(event, filter_component, param_name)

    this.applyChangesToComponents(applied_params, component_ids, param_name)
    this.reRenderFilterPartial(filter_component, applied_params)
  }

  reRenderFilterPartial(filter_component, applied_params) {
//     let url = window.location.pathname.replace("/public", "") + `/render_filter`
    applied_params["param_name"] = filter_component.data("paramName");
    applied_params["filter_type"] = filter_component.data("filterType");
    applied_params["component_id"] = filter_component.parents(".component-container").attr("id");
    applied_params["ajax_action"] = "dashboards#updateLinkedComponents"
    Rails.ajax({
      type: 'GET',
      url: this.render_filter_url,
      data: $.param(applied_params),
      dataType: 'json',
      success: (response) => {
        filter_component.html(response.template)
        initializeEngagementSliders()
        this.resizeContainer(filter_component.parents(".component-container")[0])
      }
    });
  }

  applyChangesToComponents(applied_params, component_ids, param_name) {
    document.querySelectorAll(".component-container").forEach(elem => {
      if(component_ids.includes(parseInt(elem.id))){
        $(elem).find(".content").html("");
        this.toggleSpinner(elem, "show");

        let component_type = $(elem).data("type");

        let url = $(elem).data("url");
        let params = this.getParamsFromURI(url);

        params = this.resetParams(params, param_name)
        
        for (let key in applied_params) {
          if(param_name.includes("actor_set_attributes") || param_name.includes("project_attributes")){
            params.append(`${key}`, applied_params[key])
          } else if(param_name == "keyword" || param_name == "published_at_from" || param_name == "engagement"){
            if(component_type == "channel_list" || component_type == "actor_list"){
              params.append(`post_filters[${key}]`, applied_params[key])
            } else {
              params.append(`${key}`, applied_params[key])
            }
          } else {
            applied_params[key].forEach(function(value){
              if(key == "platform_name[]" || key == "channel_ids[]" || key == "actor_ids[]" || key == "actor_set_id[]"){
                if(component_type == "actor_list" && key != "actor_set_id[]"){

                  let key_name = key.replace("[]", "")
                  params.append(`post_filters[${key_name}][]`, value)
                } else {
                  params.append(`${key}`, value)
                }
              } else if(component_type == "channel_list" || component_type == "actor_list"){
                if(key.includes("[]")){
                  let key_name = key.replace("[]", "")
                  params.append(`post_filters[${key_name}][]`, value)
                } else {
                  params.append(`post_filters[${key}]`, value)
                }
              } else {
                params.append(`${key}`, value)
              }
            })
          }
        }

        url = url.split("?")[0] + "?" + params.toString();
        this.updateComponent(elem, url)
      }
    })
  }

  resetParams(params, param_name){
    let filter_component = $(event.target).parents(".filter-component")

    params.delete(`${param_name}`);
    params.delete(`post_filters[${param_name}]`);
    if(param_name.includes("[]")){
      let key_name = param_name.replace("[]", "")
      params.delete(`post_filters[${key_name}][]`);
    }
    if(param_name == "keyword"){
      params.delete(`simple_query`);
      params.delete(`post_filters[simple_query]`);
    } else if(param_name == "published_at_from"){
      params.delete(`published_at_to`);
      params.delete(`post_filters[published_at_to]`);
    } else if(param_name == "post_details"){
      filter_component.find(".parameter-name").each(function(i, elem){
        params.delete(`${$(elem).data("name")}[]`);
        params.delete(`post_filters[${$(elem).data("name")}][]`);
      })
    } else if(param_name == "engagement"){
      filter_component.find(".engagement-select2").each(function(i, elem){
        params.delete($(this).data("param-name"))
        params.delete(`post_filters[${$(this).data("param-name")}]`);
      })
    } else if(param_name.includes("actor_set_attributes")){
      params.delete(`${param_name}[from]`);
      params.delete(`${param_name}[to]`);

      params.delete(`post_filters[${param_name}][from]`);
      params.delete(`post_filters[${param_name}][to]`);
    }

    return params
  }

  updateAndReloadComponent(event){
    event.preventDefault();

    let form = $(event.target)
    let component_id = $(event.target).data("id")
    $(`#dropdown-${component_id} .dropdown-menu`).removeClass('show').addClass("hide");

    let elem = $(`#${component_id}.component-container`)
    let json = this.convertFormToJSON(form)

    this.updateRequest(form.attr('action'), json, component_id, elem)
  }

  updateRequest(action, json_data, component_id, elem){
    let controller = this;

    Rails.ajax({
      type: 'PATCH',
      url: action,
      data: $.param(json_data),
      dataType: 'json',
      success: (response) => {
        $(`#edit_modal_${component_id}`).modal('hide');
        $(`#edit_modal_${component_id} input[type="submit"]`).attr("disabled", false);
        $(`#dropdown-${component_id} input[type="submit"]`).attr("disabled", false);

        this.resizeComponent($(elem).parents(".grid-stack-item")[0], {w: response.component.width, h: response.component.height})

        $(elem).find(".content").html("");
        this.toggleSpinner(elem, "show");

        setTimeout(function(){
          //update title
          let new_title = json_data["dashboard_component[title]"]
          $(elem).parent().find(".component-title").text(new_title);

          //update description
          let new_description = json_data["dashboard_component[description]"]
          $(elem).parent().find(".card-header header .small").text(new_description);

          //reset url
          let url = elem.data("url");
          url = url.split("?")[0]

          //reload component
          controller.updateComponent(elem[0], url);
        }, 1000)
      },   
      error: (response) => {
        alert(response.message);
        $(`#edit_modal_${component_id} input[type="submit"]`).attr("disabled", false);
      }
    });  
  }

  resizeComponent(item, update_data){
    let grid = $(".grid-stack").data("gridstack-instance");
    let currentX = parseInt($(item).attr("gs-x"));

    if(currentX + update_data.w > 12){
      let currentY = parseInt($(item).attr("gs-y"))
      update_data["y"] = currentY + 37
      update_data["x"] = 0
    }

    grid.update(item, update_data);
  }

  createAndRenderComponent(event) {
    event.preventDefault();
    let form = $(event.target);
    let json = this.convertFormToJSON(form);
    let form_url = form.attr('action');

    Rails.ajax({
      type: 'POST',
      url: form_url,
      data: $.param(json),
      dataType: 'json',
      success: (response) => {
        let url = form_url + `/${response.component_id}/template`
        this.renderTemplate(response.component_id, url);

        $(`#new_component_modal`).modal('hide');
        $(`#new_component_modal input[type="submit"]`).attr("disabled", false);
        event.target.reset();
      },
      error: (response) => {
        alert(response.message);
        $(`#new_component_modal input[type="submit"]`).attr("disabled", false);
      }
    });
  }

  renderTemplate(component_id, template_url) {
    Rails.ajax({
      type: 'GET',
      url: template_url,
      dataType: 'json',
      success: (response) => {
        let grid = $(".grid-stack").data("gridstack-instance");
        let style = "border-radius: 10px; inset: 5; overflow: visible;"
        let component_class = `dashboard-component__${response.component_type}`
        grid.addWidget(`<div class="grid-stack-item" id="stack-item-${component_id}"><div class="dashboard-component m-0 p-0 grid-stack-item-content border border-grey shadow-sm border-grey ${component_class}" style="${style}">${response.template}</div></div>`, response.component_dimensions);
      }
    });
  }

  updateComponent(elem, url){
    Rails.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      success: (response) => {
        this.toggleSpinner(elem, "hide");
        $(elem).find(".content").html(response);
        $(elem).data("url", url)
        
        var chart_container_id = `.line-chart-${elem.id}`
        if($(chart_container_id)) {
          var grid_item = $(`#stack-item-${elem.id} #${elem.id}`);
          this.initializeChartConfiguration(elem)
          initializeChart(chart_container_id, grid_item, this.chart_configuration[elem.id])
        }
        this.resizeContainer(elem)
      }
    });
  }

  resizeContainer(elem){
    let final_height = 0
    let adjust_height = false
    let description_present = $(elem).parent().find(".component-description").text().length > 0
    if($(elem).data("type") == "filter_container"){
      adjust_height = true
      let grid = $(".grid-stack").data("gridstack-instance");
      let height_variable = 9
      if(description_present == true) height_variable += 2
      let content_height = Math.ceil($(elem).find(".content").height()/10) + height_variable
      
      let item = $(elem).parents(".grid-stack-item")[0]

      grid.update(item, {h: content_height});
      final_height = $(elem).find(".content").height() + 20
      description_present = false
    } else if($(elem).data("type").includes("post_list")){
      adjust_height = true
      let item_height = $(elem).parents(".grid-stack-item-content").height()
      final_height = item_height - 30
    } else if($(elem).data("type").includes("_list")){
      adjust_height = true
      let item_height = $(elem).parents(".grid-stack-item-content").height()
      final_height = item_height - 25
    } else if($(elem).data("type") == "heading_and_text"){
      adjust_height = true
      let item_height = $(elem).parents(".grid-stack-item-content").height()
      final_height = item_height - 40
    } 

    if(adjust_height){
      if(description_present == true){
        final_height = final_height - 30
      }
      $(elem).height(final_height)
    }
    
  }

  getParamsFromURI(uri) {
    // Get everything after the `?`
    const [ , paramString ] = uri.split( '?' );
  
    // Return parameters
    return new URLSearchParams( paramString );
  }

  disconnect() {
  }

  convertFormToJSON(form) {
    return $(form)
      .serializeArray()
      .reduce(function (json, { name, value }) {
        if(name.includes("[]")){
          if(name in json){
            json[name].push(value)
          } else {
            json[name] = [value]
          }
        } else {
          json[name] = value;
        }
        return json;
      }, {});

  }

  connectNewModalOpenEvent(){
    $('#new_component_modal').on('show.bs.modal', function (event) {
      var button = $(event.relatedTarget);
      var component_type = button.data('type');

      var modal = $(this);
      var type_field = modal.find('.modal-body input#dashboard_component_component_type');

      type_field.val(component_type)

      const change_event = new Event('change', { bubbles: true });
      type_field[0].dispatchEvent(change_event);
    })
  }

  duplicateComponent(event){
    event.preventDefault();
    var component_id = $(event.target).data("componentId")
    console.log(component_id)

    Rails.ajax({
      type: 'POST',
      url: `dashboard_components/${component_id}/create_duplicate`,
      dataType: 'json',
      success: (response) => {
        let url = `dashboard_components/${response.component_id}/template`
        this.renderTemplate(response.component_id, url);
      },   
      error: (response) => {
        alert(response.message);
      }
    });

  }
}
